import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
};

const Head = ({ children, className, wrapperClassName }) => {
  const classes = classNames({
    'pro-wrapper-head': true,
    [className]: !!className,
  });

  const wrapperClasses = classNames({
    'pro-wrapper-head-wrap': true,
    [wrapperClassName]: !!wrapperClassName,
  });

  return (
    <div className={classes}>
      <div className={wrapperClasses}>{children}</div>
    </div>
  );
};

Head.propTypes = propTypes;

export default Head;
